<div>
  <p class="text">You cannot access this page!</p>
  <img src="../assets/images/sad-panda.jpeg" alt="sad panda" />
  <div class="buttons">
    <button *ngIf="loggedIn" mat-stroked-button (click)="logout()">Sign Out</button>
    <button *ngIf="!loggedIn" mat-stroked-button (click)="login()">Sign In</button>
  </div>
</div>
